/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Deactivate_Typetoconfirm4Inputs */

const en_settings_reportingapikeys_deactivate_typetoconfirm4 = /** @type {(inputs: Settings_Reportingapikeys_Deactivate_Typetoconfirm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type DEACTIVATE to confirm`)
};

/**
* | output |
* | --- |
* | "Type DEACTIVATE to confirm" |
*
* @param {Settings_Reportingapikeys_Deactivate_Typetoconfirm4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_deactivate_typetoconfirm4 = /** @type {((inputs?: Settings_Reportingapikeys_Deactivate_Typetoconfirm4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Deactivate_Typetoconfirm4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_deactivate_typetoconfirm4(inputs)
});
export { settings_reportingapikeys_deactivate_typetoconfirm4 as "settings_reportingApiKeys_deactivate_typeToConfirm" }